import { SegmentedControl } from "./SegmentedControl";

interface AlignmentControlProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * Two-button segmented control for left/center alignment.
 */
export function AlignmentControl({ value, onChange }: AlignmentControlProps) {
  return (
    <SegmentedControl
      label="Alignment"
      options={[
        { label: "Left", value: "left" },
        { label: "Center", value: "center" },
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
